<template>
  <div>
    <section class="product-head">
      <div class="main-content">
        <h2>产品与服务</h2>
        <p>丰富可靠的智能产品+高效稳定的智能服务，为您提供高性价比的服务
          <button><a href="#business" style="text-decoration: none;color: #fff;">了解更多</a></button>
        </p>
      </div>
    </section>

    <section>


      <div class="list">
        <el-container>
          <el-aside width="200px" class="product-aside">
            <el-menu default-active="activeIndex" @select="handleSelect">
              <el-menu-item-group>
                <el-menu-item index="4">
                  <a href="#ALL"><img v-bind:src="overviewPng" width="30"/>&nbsp;&nbsp;&nbsp;产品总览表</a>
                </el-menu-item>
                <el-menu-item v-for="(item, index) in categories" :key="index" :index="index + ''" @click="highlightMenu">
                  <a :href="item.href">{{item.type}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.title}}</a>
                </el-menu-item>
              </el-menu-item-group>
            </el-menu>
          </el-aside>
          <el-container>
            <el-main style="width:950px">
              <ul>
                <li id="ALL">
                  <img v-lazy="product_table" width="860" height="422" style="margin-bottom: 20px"/>
                </li>
                <li v-for="(item, index) in productItems" :key="index" :id="item.id">
                  <div class="line" v-if="index!=0"></div>
                  <el-row :gutter="25" style="-ms-flex-wrap:nowrap;flex-wrap: nowrap">
                    <el-col :span="18">
                      <div class="header">
                        <i class="headerIcon sudoku-product" v-bind:class="item.icon"></i>
                        <div class="product_title">{{item.title}}</div>
                      </div>
                      <p v-html="item.content"></p>
                      <div class="experience">
                        <button class="button button-calm" @click="tryNow(item)">立即体验</button>
                        <button class="button button-calm"
                                style="background: #FFFFFF;border: 1px solid #4E84E0;color: #4E84E0;margin-left: 10px"
                                @click="play(item)"
                                v-if="item.videoUrl!=''">演示视频
                        </button>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <img v-lazy="item.cover" width="184px" @click="play(item)"
                           v-bind:style="{cursor:item.videoUrl==null?'default':'pointer'}"/>
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </el-main>
          </el-container>
        </el-container>
      </div>

    </section>

    <el-dialog title="立即体验" class="tryNow" :visible.sync="dialogVisible_1" :close-on-press-escape="false"
               width="68%">
      <el-row>
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="text-center userInfo">
          <p>体验方式：呼入电话</p>
          <div><img :src="call_1" width="90%"/></div>
          <div><img :src="call_2" width="90%"/></div>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
          <p style="font-size: 20px;color: #000;margin-bottom: 40px">或者微信加入客户群组体验交流</p>
          <img v-lazy="ercode_2" width="230px"/>
          <p style="font-size: 18px;color: #999;margin: 10px 0 30px">微信扫码，快速入群</p>
        </el-col>
      </el-row>
    </el-dialog>

    <collect-user-info-dialog :show.sync="dialogVisible_2"></collect-user-info-dialog>

    <el-dialog class="showVideo" :visible.sync="dialogVisible_3" :close-on-press-escape="false" width="68%" height="420px" :before-close="handleClose">

      <video :src="dialogVideoUrl" autoplay controls preload="none" width="100%" height="420px"></video>
    </el-dialog>
  </div>
</template>

<script>
  import ElCol from 'element-ui/packages/col/src/col';
  import ElRow from 'element-ui/packages/row/src/row';
  import CollectUserInfoDialog from "./CollectUserInfoDialog.vue";

  import overview from '../assets/img/product_overview.png';
  import overview_chosed from '../assets/img/product_overview_chosed.png';
  import product_table from '../assets/img/product_table.png';
  import ercode_2 from "../assets/img/ercode_2.png"

  import cover_A1 from '../assets/img/cover/cover_A1.png';
  import cover_A2 from '../assets/img/cover/cover_A2.png';
  import cover_A3 from '../assets/img/cover/cover_A3.png';
  import cover_A4 from '../assets/img/cover/cover_A4.png';
  import cover_B1 from '../assets/img/cover/cover_B1.png';
  import cover_B2 from '../assets/img/cover/cover_B2.png';
  import cover_B3 from '../assets/img/cover/cover_B3.png';
  import cover_C1 from '../assets/img/cover/cover_C1.png';
  import cover_C2 from '../assets/img/cover/cover_C2.png';
  import cover_C3 from '../assets/img/cover/cover_C3.png';
  import cover_C4 from '../assets/img/cover/cover_C4.png';
  import cover_C5 from '../assets/img/cover/cover_C5.png';
  import cover_C6 from '../assets/img/cover/cover_C6.png';
  import cover_C7 from '../assets/img/cover/cover_C7.png';
  import cover_C8 from '../assets/img/cover/cover_C8.png';
  import cover_C9 from '../assets/img/cover/cover_C9.png';
  import cover_C10 from '../assets/img/cover/cover_C10.png';
  import cover_C11 from '../assets/img/cover/cover_C11.png';
  import cover_C12 from '../assets/img/cover/cover_C12.png';
  import cover_C13 from '../assets/img/cover/cover_C13.png';
  import cover_C14 from '../assets/img/cover/cover_C14.png';
  import cover_C15 from '../assets/img/cover/cover_C15.png';
  import cover_C16 from '../assets/img/cover/cover_C16.png';
  import cover_D1 from '../assets/img/cover/cover_D1.png';
  import cover_D2 from '../assets/img/cover/cover_D2.png';
  import cover_D3 from '../assets/img/cover/cover_D3.png';
  import cover_D4 from '../assets/img/cover/cover_D4.png';
  import cover_D5 from '../assets/img/cover/cover_D5.png';
  import cover_D6 from '../assets/img/cover/cover_D6.png';

  import call_1 from '../assets/img/call_1.png';
  import call_2 from '../assets/img/call_2.png';

  import video_A2 from '../assets/videos/A2.mp4';
  import video_A3 from '../assets/videos/A3.mp4';
  import video_C1 from '../assets/videos/C1_1.mp4';
  import video_C2 from '../assets/videos/C2.mp4';
  import video_C3 from '../assets/videos/C3.mp4';
  import video_C4 from '../assets/videos/C4.mp4';
  import video_C5 from '../assets/videos/C5.mp4';
  import video_C7 from '../assets/videos/C7.mp4';
  import video_C9 from '../assets/videos/C9.mp4';
  import video_C10 from '../assets/videos/C10.mp4';
  import video_C12 from '../assets/videos/C12.mp4';
  import video_C13 from '../assets/videos/C13.mp4';
  import video_C15 from '../assets/videos/C15.mp4';
  import video_E1 from '../assets/videos/E1.mp4';
  import video_E2 from '../assets/videos/E2.mp4';
  import video_E3 from '../assets/videos/E3.mp4';
  import video_E6 from '../assets/videos/E6.mp4';
  import video_E7 from '../assets/videos/E7.mp4';
  import video_E8 from '../assets/videos/E8.mp4';

  export default {
    name: 'Product',
    components: {
      ElRow,
      ElCol
    },
    data () {
      return {

        dialogVisible_1: false,
        dialogVisible_2: false,
        ercode_2: ercode_2,
        call_1:call_1,
        call_2:call_2,
        userName: '',
        phoneNo: '',
        eMail: '',
        company: '',
        dialogVisible_3: false,
        dialogVideoUrl: '',
        dialogVideoPoster: '',
        overviewPng:overview,
        overview: overview,
        overview_chosed: overview_chosed,
        product_table: product_table,
        categories: [{
          type: 'A',
          title: '平台',
          href: '#A1'
        }, {
          type: 'B',
          title: '系统',
          href: '#B1'
        }, {
          type: 'C',
          title: '智能应用',
          href: '#C1'
        }, {
          type: 'D',
          title: '人力外包',
          href: '#D1'
        }],

        productItems: [{
          id: 'A1',
          icon: 'sudoku-A1',
          title: 'A1  一站式数字电话平台服务',
          content: "<p>平安金服一站式数字电话平台，云部署，专业运营运维团队7x24-站式全托管服务，让您无需部署无需整合资源，即可轻松拥有专家级电话平台服务。<br/>可扩展强:一键多呼、预测式外呼、号码隐藏应用等。<br/>智能应用：自动IVR外呼、人机语音交互、可视化IVR应用等。</p>",
          cover: cover_A1,
          videoUrl: ''
        }, {
          id: 'A2',
          icon: 'sudoku-A2',
          title: "A2  智能电话机",
          content: "<p>有网环境(专线/Internet'wifi)下，直接使用固定话机，通过语音流后传转译，实时将语音转成文字，并建立模型进行结构化分析。 <br/>功能: 模拟线对接、分散话机后台集中管理、智能语音分析。</p>",
          cover: cover_A2,
          videoUrl: video_A2
        }, {
          id: 'A3',
          icon: 'sudoku-A3',
          title: "A3  一站式多媒体视频平台服务",
          content: "<p>由平安自主开发，集成了在线核身、远程风控以及智能识别等智能化模块、高风险金融业务、现场查勘类业务的远程模式更新、 同时兼具各金融业务场景的视频服务。</p>",
          cover: cover_A3,
          videoUrl: video_A3
        }, {
          id: 'A4',
          icon: 'sudoku-A4',
          title: "A4  智能一体机",
          content: "<p>智能一体机可通过身份证、移动电话、人脸识别等多种方式进行客户身份登录，在自动打印交强险、商业保险、标签的同时，自动留存凭证底单；快速远程呼叫服务人员，并进行视频或语音沟通辅助完成相关业务办理；自助进行报案、理赔申请，提交验证相关证明文件和照片。</p>",
          cover: cover_A4,
          videoUrl: ''
        }, {
          id: 'B1',
          icon: 'sudoku-B1',
          title: "B1  通用客服作业系统",
          content: "<p>能够支持基本通用的客服作业记录和操作的系统，可支持定制化开发。可配合云电话平台，为中小型企业提供客服类业务场景呼叫中心应用。</p>",
          cover: cover_B1,
          videoUrl: ''
        }, {
          id: 'B2',
          icon: 'sudoku-B2',
          title: "B2  催收系统",
          content: "<p>平安自主研发， 专业处理银行、小贷、P2P、委外催收公司等企业逾期账款的催收管理系统，根据平安专业经验， 提炼业务策略应用，可以显著提升效率的全线金融催收管理系统。</p>",
          cover: cover_B2,
          videoUrl: ''
        }, {
          id: 'B3',
          icon: 'sudoku-B3',
          title: "B3  通用电销系统",
          content: "<p>面向中小型企业的，业务效率优先的CRM系统。可配合云电话平台，为中小型企业提供电销/催收类业务场景呼叫中心应用。</p>",
          cover: cover_B3,
          videoUrl: ''
        }, {
          id: 'C1',
          icon: 'sudoku-C1',
          title: "C1  智能知识平台",
          content: "<p>提供知识图谱，智能知识拆解、知识管理等全套知识管理解决方案，是全方位、多媒体、面向综合对象的智能化知识应用平台，提供知识服务的共识，支持各种业务系统、机器人等全渠道知识应用模式，在原有门户查询基础上，扩展出知识系统化、自动化的深度应用模式。</p>",
          cover: cover_C1,
          url: 'C1',
          videoUrl: video_C1
        }, {
          id: 'C2',
          icon: 'sudoku-C2',
          title: "C2  智能坐席助手",
          content: "<p>基于语音音转字与语义理解技术，并结合知识库，实现客户需求识别与知识答案或优秀话术智能推送。</p>",
          cover: cover_C2,
          videoUrl: video_C2
        }, {
          id: 'C3',
          icon: 'sudoku-C3',
          title: "C3  电话客服实时监控(情绪/话术)",
          content: "<p>基于语音与语义情绪识别技术，实时侦测客户与坐席的清晰及合规表达，实现坐席的主动提醒与现场主管实时介入。</p>",
          cover: cover_C3,
          videoUrl: video_C3
        }, {
          id: 'C4',
          icon: 'sudoku-C4',
          title: "C4  智能质检系统",
          content: "<p>利用智能语音及语义分析技术，根据业务提供的质检规则条件，快速定位质检点或挖掘客户需求，提高质检效率或销售成功率。</p>",
          cover: cover_C4,
          videoUrl: video_C4
        }, {
          id: 'C5',
          icon: 'sudoku-C5',
          title: "C5  智能语音交互",
          content: "<p>在人机语音交互中，允许用户以开放的方式任意说话，系统将用户的语音转换为文本，自动理解用户的自然语言中包含的准确意图，并自动用语音回复用户。包括智能语音导航、智能语音回答、智能语音外呼三个模块。</p>",
          cover: cover_C5,
          videoUrl: video_C5
        }, {
          id: 'C6',
          icon: 'sudoku-C6',
          title: "C6  印章管理平台",
          content: "<p>印章线上化管理平台，包括申请、审批、用印等盖章风控流程，还包含印章员排版、工作及盖章数据报表等后台管理功能，做到盖章全程可追溯。</p>",
          cover: cover_C6,
          videoUrl: ''
        }, {
          id: 'C7',
          icon: 'sudoku-C7',
          title: "C7  文本机器人",
          content: "<p>基于机器学习、具备高度语义理解和深度自学能力的客服机器人。拥有18年的业务知识积累，10万条客服级知识，40万条客服级词条，通过场景+模型+业务积累来实现业务价值。</p>",
          cover: cover_C7,
          videoUrl: video_C7
        }, {
          id: 'C8',
          icon: 'sudoku-C8',
          title: "C8  智能消息",
          content: "<p>投递在客户手机屏幕的最上层，非点击关闭一直显示，“强制客户”阅读，强化用户互动，增加客户黏性，保证信息使命必达。</p>",
          cover: cover_C8,
          videoUrl: ''
        }, {
          id: 'C9',
          icon: 'sudoku-C9',
          title: "C9  超级微视频",
          content: "<p>文字、图片、微视频等多种媒介以短信形式发送至客户短信箱，本产品主要是“微视频”的创新，多用在APP操作指引类。</p>",
          cover: cover_C9,
          videoUrl: video_C9
        }, {
          id: 'C10',
          icon: 'sudoku-C10',
          title: "C10  智能弹屏",
          content: "<p>通话中，通话界面弹屏，点击可跳转至网页或APP，实现多通道协同，缩短业务办理路径 ，提升用户体验。</p>",
          cover: cover_C10,
          videoUrl: video_C10
        }, {
          id: 'C11',
          icon: 'sudoku-C11',
          title: "C11  智能语义标注平台",
          content: "<p>自主知识产权语义标注平台， 包含长文本标注和短文本标注，支持文档抽取、命名实体标注、分词标注、情感标注、分类意图标注、上下文对话标注等， 有效力NLP应用输入必要业务规则及数据。</p>",
          cover: cover_C11,
          videoUrl: ''
        }, {
          id: 'C12',
          icon: 'sudoku-C12',
          title: "C12  智能语音标注平台",
          content: "<p>使用机器预处理+人工纠正的模式，结合完善的自动分发、统计及质检体系、纯在线工作及管理的高效管理机制，可高效的完成标注作业。为语音机器人、文本机器人、智能客服系统等各类人工智能产品提供标注支持，提升智能产品生产效果。</p>",
          cover: cover_C12,
          videoUrl: video_C12
        }, {
          id: 'C13',
          icon: 'sudoku-C13',
          title: "C13  智能财务合同风控及标注平台",
          content: "<p>利用深度学习和OCR技术，抽取各类型文档中需专业人员审核的关键字段和条款，并自动与关联材料及扫描件进行比对，辅助作业人员识别潜在风险，提高企业财务风控，提高工作效率。</p>",
          cover: cover_C13,
          videoUrl: video_C13
        }, {
          id: 'C14',
          icon: 'sudoku-C14',
          title: "C14  电子签章平台",
          content: "<p>是一款线上加盖电子签章的系统，支持证书托管和UKEY两种身份验证方式，用户申请时需通过CA认证，就可合法地使用自己的电子签章，利于光学防伪技术，事项防合同篡改、便捷盖章，合同存档、印章集中管理、电子化合同等功能。</p>",
          cover: cover_C14,
          videoUrl: ''
        }, {
          id: 'C15',
          icon: 'sudoku-C15',
          title: "C15  智能门店服务机器人",
          content: "<p>辅助/取代门店前台人员，向到店客户提供服务/娱乐。具体功能包括：<br>1.取号、APP操作等指引，产品介绍；2.门店特色服务介绍、引导；3.提供娱乐，联动门店电视，提供影视娱乐；4.空中客服；5.客户体验机器人操作。</p>",
          cover: cover_C15,
          videoUrl: video_C15
        }, {
          id: 'C16',
          icon: 'sudoku-C16',
          title: "C16  柜面客户满意度分析机器人",
          content: "<p>辅助/取代质检人员，全量客观对柜面服务质量进行评价。具体功能包括：<br>1.自动化客户满意度评价、月度服务业绩考核；<br>2.客户投诉预防。</p>",
          cover: cover_C16,
          videoUrl: ''
        }, {
          id: 'D1',
          icon: 'sudoku-D1',
          title: "D1  电话坐席",
          content: "<p>可承包客服、催收、电销、风控审核、车商引流、交通服务咨询等场景呼叫中心人力外包服务，具备保险、银行、贷款、投资、汽车、政务等多领域专业经营和客服经验，拥有10多年团队管理和业务品质管理经验，以及新技术和新模式应用方案支持。</p>",
          cover: cover_D1,
          videoUrl: ''
        }, {
          id: 'D2',
          icon: 'sudoku-D2',
          title: "D2  视频坐席",
          content: "<p>可承包远程视频风控类和查勘类人力外包服务，支持车险远程视频查勘、贷款远程审核，高风险服务等高价值业务场景，坐席队列专业技术过硬，形象气质佳。结合智能及新技术，实现各入口渠道的服务。</p>",
          cover: cover_D2,
          videoUrl: ''
        }, {
          id: 'D3',
          icon: 'sudoku-D3',
          title: "D3  人工语音标注（音转字、语音情绪等）",
          content: "<p>受过专业培训的标注专家，可提供语音音转字标注、语义理解标注等服务；包含高效管理的在线标注工具；包含标注质检。</p>",
          cover: cover_D3,
          videoUrl: ''
        }, {
          id: 'D4',
          icon: 'sudoku-D4',
          title: "D4  人工语义标注（智能语音、文本机器人应用等）",
          content: "<p>对金融场景有深入理解，可提供场景对话和语义的意图、实体等人力外包标注服务，比普通标注市场人员懂金融垂直业务，标注品质高，数据可用性极高，可极大促进提高智能应用模型的识别准确率。</p>",
          cover: cover_D4,
          videoUrl: ''
        }, {
          id: 'D5',
          icon: 'sudoku-D5',
          title: "D5  合同及文档语义标注",
          content: "<p>对各类合同进行抽取标记人力外包服务，有几十种合同标注经验和业务积累，可供智能合同和文本比对模型训练所用。</p>",
          cover: cover_D5,
          videoUrl: ''
        }, {
          id: 'D6',
          icon: 'sudoku-D6',
          title: "D6  知识梳理",
          content: "<p>电话中心、服务中心人员所用的业务知识梳理外包服务，搭配智能知识平台服务一起提供。</p>",
          cover: cover_D6,
          videoUrl: ''
        }]
      }
    },
    methods: {
      getLocal(){

        var hashID = localStorage.getItem('hashID');

        var hashIDEle = document.getElementById(hashID);

        if (hashID) hashIDEle.scrollIntoView({
          behavior: "smooth"
        })
      },
      closeDialog(){
        this.userName = '';
        this.phoneNo = '';
        this.eMail = '';
        this.company = '';
      },
      handleClose(){
        var video = document.getElementsByTagName('video');
        if(video[0]) {// && !video[0].paused

          video[0].pause();
          this.dialogVisible_3 = false;
        }
      },
      tryNow(item){
        if (item.title.indexOf('C5') > -1) this.dialogVisible_1 = true;
        if (item.title.indexOf('C5') == -1) this.dialogVisible_2 = true;
      },
      play(item){
        if(item.videoUrl != ''){
          this.dialogVisible_3 = true;
          this.dialogVideoUrl = item.videoUrl;
        }
      },
      isVisible (ele) {
        var elementTop = $(ele).offset().top;
        var elementBottom = elementTop + $(ele).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;

        return elementBottom > viewportTop && elementTop < viewportBottom;
      },
      handleScroll (event) {
        var _this = this;
        $('main.el-main ul li').each(function () {
          if (_this.isVisible(this)) {
            var firstVisiableId = (this.id.charAt(0));
            $('ul.el-menu ul li').each(function(a) {
              if (a != 0) {
                if ($(this).find('a').attr('href').indexOf(firstVisiableId) > -1) {
                  $(this).addClass('is-active');
                } else {
                  $(this).removeClass('is-active');
                }
              }
            });

            return false;
          }
        });
      },
      highlightMenu (event) {
        window.scroll(window.scrollX, window.scrollY + 1);
      },
      handleSelect(key, keyPath){
        if(key == 4) this.overviewPng = this.overview_chosed
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Product.vue